import { render, staticRenderFns } from "./component-chat.vue?vue&type=template&id=c6a9ddfe&scoped=true&"
import script from "./component-chat.vue?vue&type=script&lang=js&"
export * from "./component-chat.vue?vue&type=script&lang=js&"
import style0 from "./component-chat.vue?vue&type=style&index=0&id=c6a9ddfe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a9ddfe",
  null
  
)

export default component.exports